/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)


import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'

flatpickr(".datepicker", {
  enableTime: true
});

flatpickr("#sales-figures-daterangepicker", {
  mode: "range",
  onChange: function(selectedDates, dateStr, instance) {
    if(selectedDates.length == 2) {
      $("form#sales-figures-filter input#start_time").val(selectedDates[0].toDateString()).removeAttr("disabled");
      $("form#sales-figures-filter input#end_time").val(selectedDates[1].toDateString()).removeAttr("disabled");
      $("form#sales-figures-filter input#filter").val("Custom");

      $("a.isbn-date-filter").removeClass("bg-launch-blue1 text-white border-launch-blue1").addClass("border-secondary");
      $("btn#sales-figures-daterangepicker").addClass("bg-launch-blue1 text-white border-launch-blue1").removeClass("border-secondary");
    }
  }
});

